import React, { useContext, useEffect, useState } from 'react';
import { Grid } from '@material-ui/core';
import { Button } from '@one-thd/sui-atomic-components';
import { InfoPerksContext } from '../../../../contexts';
import { LazyImage } from '../../../shared/LazyImage';
import { useCurrentPerkStatusDetails, getIfPreviousPerk3Lines } from '../utils';
import { perksHistory } from '../../../../constants';
import { getImageURL } from '../../../../utils/GeneralUtil';
import { ProgressBarMobile, ProgressBarMobileLast } from './ProgressBarMobile';
import { SmallAlert } from '../../shared/components/SmallAlert/SmallAlert';
export var HistoryCarouselMobile = function () {
    var _a = useContext(InfoPerksContext), perkHistoryList = _a.perkHistoryList, earnedPerkHistoryCount = _a.earnedPerkHistoryCount, isLoading = _a.isLoading;
    var getCurrentPerkStatusDetails = useCurrentPerkStatusDetails();
    var _b = useState(false), showUpcomingPerks = _b[0], setShowUpcomingPerks = _b[1];
    var _c = React.useState([]), perksViewList = _c[0], setPerksViewList = _c[1];
    var showButton = earnedPerkHistoryCount !== perkHistoryList.length;
    useEffect(function () {
        setPerksViewList(showUpcomingPerks
            ? perkHistoryList
            : perkHistoryList.slice(0, earnedPerkHistoryCount + 1));
    }, [showUpcomingPerks]);
    if (isLoading || !perkHistoryList) {
        return null;
    }
    var slides = perksViewList.map(function (perk, index) {
        var currentPerkStatusDetails = getCurrentPerkStatusDetails(perk);
        var currentPerkDetails = perk.perkDisplaySeqNumber
            ? perk
            : perk.tierPerks[0];
        var isLast = index === perksViewList.length - 1;
        var bottomBorder = isLast
            ? ''
            : 'sui-border-b-1 sui-border-solid sui-border-primary';
        var mainLabel = currentPerkStatusDetails.title === 'Customer Service Issued' ||
            (currentPerkDetails.perkStatus === 'EXPIRED' &&
                currentPerkDetails.bulkIssued)
            ? ''
            : currentPerkStatusDetails.title;
        var isPreviousPerk3Lines = !index
            ? false
            : getIfPreviousPerk3Lines(perksViewList[index - 1]);
        var progressBarWidth = 65;
        if (isPreviousPerk3Lines) {
            progressBarWidth += 24;
        }
        if (index > 0 && perksViewList[index - 1].daysLeft <= 14) {
            progressBarWidth += 32;
        }
        return (React.createElement(Grid, { key: "card-".concat(index), container: true, item: true, xs: 12, className: "sui-flex sui-flex-row sui-justify-start sui-align-center" },
            React.createElement(Grid, { item: true, xs: 2, className: "sui-flex sui-flex-col sui-justify-start sui-align-center" },
                React.createElement(ProgressBarMobile, { barHeight: progressBarWidth, index: index, completed: currentPerkDetails.adminIssued ? 100 : perk.progressPercentage }),
                React.createElement(LazyImage, { src: getImageURL(currentPerkStatusDetails.imgName), altText: currentPerkStatusDetails.imgAltText, classes: "PerkHistoryLogo sui-flex sui-flex-row sui-justify-center sui-align-center", height: "32px", width: "32px" }),
                isLast && React.createElement(ProgressBarMobileLast, null)),
            React.createElement(Grid, { item: true, xs: 10, className: "sui-pb-4 ".concat(bottomBorder, " sui-flex sui-flex-col sui-justify-start sui-align-center ").concat(!index ? 'sui-pt-5' : 'sui-pt-3') },
                React.createElement(Grid, { item: true, xs: 12, className: "sui-flex sui-flex-row sui-justify-start sui-align-center" },
                    React.createElement(Grid, { item: true, xs: 3, className: "PerkHistoryTitle" },
                        React.createElement("p", null, mainLabel)),
                    React.createElement(Grid, { item: true, xs: 9, className: "sui-flex sui-flex-col sui-justify-start sui-align-start sui-pl-2" },
                        !currentPerkDetails.adminIssued &&
                            (currentPerkDetails.renewed ||
                                currentPerkDetails.exchanged) && (React.createElement(Grid, { className: "PerkHistoryChipIcon" },
                            React.createElement("p", null, currentPerkDetails.renewed
                                ? perksHistory.renewed
                                : perksHistory.exchanged))),
                        currentPerkStatusDetails.title === 'Customer Service Issued' && (React.createElement(Grid, { className: "sui-pb-2" }, currentPerkStatusDetails.title)),
                        React.createElement(Grid, { className: "sui-pb-2" }, currentPerkStatusDetails.caption),
                        React.createElement(Grid, { className: "PerkHistorySubCaption" }, currentPerkStatusDetails.subCaption))),
                currentPerkDetails.daysLeft <= 14 && (React.createElement(Grid, { item: true, xs: 12, className: "PerkHistorySubCaption sui-flex sui-flex-row sui-justify-center sui-align-center sui-mt-2 sui-pt-2" },
                    React.createElement(SmallAlert, { alertMessage: currentPerkStatusDetails.alertMessage, isMultiLine: false }))))));
    });
    return (React.createElement(Grid, null,
        React.createElement(Grid, { className: "sui-pb-5 sui-pt-4 sui-pl-4 PerksHistorySummary" }, perksHistory.summary),
        React.createElement(Grid, { className: "PerkHistory__Mobile sui-flex sui-flex-col sui-justify-start sui-align-center" }, slides),
        showButton && (React.createElement(Grid, null,
            React.createElement("div", { className: "PerkHistory__MobileButtonContainerTop" }),
            React.createElement("div", { className: "PerkHistory__MobileButtonContainer" },
                React.createElement(Button, { variant: "primary", onClick: function () { return setShowUpcomingPerks(!showUpcomingPerks); } }, showUpcomingPerks ? 'Hide Upcoming Perks' : 'Show All Perks'))))));
};
